import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Snackbar, Alert } from "@mui/material";
import { login } from "../../context/authContext/AuthApiCalls";
import { AuthContext } from "../../context/authContext/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import {
  validateFiled,
  validateEmail,
} from "../../components/validation/Validation";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 5px;
  margin-bottom: 5px;
  font-size: 16px;
  border: none;
  border-bottom: 1px solid ${(props) => (props.error ? "red" : "gray")};
  color: ${(props) => (props.error ? "red" : "black")};
`;

const LoginButton = styled.button`
  margin-top: 10px;
  padding: 7px 10px;
  border: none;
  border-radius: 5px;
  background-color: #88bfd3;
  color: white;
  font-weight: 600;
  cursor: pointer;
  height: 40px;
  width: 100%;
  align-self: center;
  &:disabled {
    background-color: lightgray;
  }
`;

const Login = () => {
  let location = useLocation();
  let navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { error, errorData, isFetching, dispatch } = useContext(AuthContext);

  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const validate = () => {
    let validEmail = !validateEmail(email);
    setEmailError(validEmail);
    let validPassword = !validateFiled(password);
    setPasswordError(validPassword);
    return validEmail || validPassword;
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!validate()) {
      login({ email, password }, dispatch).then(() => {
        navigate(location.state ? location.state : "/dashboard");
      });
    }
  };

  return (
    <Container>
      <Snackbar
        open={error}
        autoHideDuration={1000}
        //onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorData}
        </Alert>
      </Snackbar>
      <Form>
        <Title>Aradas Customer Portal</Title>
        <Input
          type="text"
          autoComplete="username"
          error={emailError || error}
          placeholder="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          type="password"
          autoComplete="current-password"
          error={passwordError || error}
          placeholder="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <LoginButton onClick={handleLogin} disabled={isFetching}>
          Login
        </LoginButton>
      </Form>
    </Container>
  );
};

export default Login;
